// extracted by mini-css-extract-plugin
var _1 = "MultiValuedLists-modulecontent__G47t4";
var _2 = "MultiValuedLists-moduleitem__gW_Ug";
var _3 = "MultiValuedLists-moduleitemContent__jfS1i";
export { _1 as "content", _2 as "item", _3 as "itemContent" }
